import { Link } from "react-router-dom";
import { ArrowLeft, User, MessageSquareText, CheckCircle2 } from "lucide-react";

const STEPS = [
  "Open the Curtron Hub app or visit curtronhub.com and sign in",
  'Tap Profile in the bottom navigation',
  'Toggle "Receive dispatch alerts by text message" to ON',
  "Your opt-in is recorded with a timestamp; you'll begin receiving SMS notifications the next time an admin assigns you a transport call",
];

export default function OptIn() {
  return (
    <div className="min-h-screen w-full" style={{ background: "radial-gradient(ellipse at top, #1F2D7A 0%, #0B1437 55%, #050A1C 100%)" }}>
      <div className="mx-auto max-w-[720px] px-4 py-8">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-white/70 hover:text-white mb-4" data-testid="optin-back">
          <ArrowLeft className="w-4 h-4" /> Back to sign in
        </Link>
        <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-9">
          <div className="flex items-center gap-2.5 mb-6">
            <img src="/curtron-emblem.png" alt="Curtron" className="h-6 w-auto" />
            <div>
              <div className="font-heading font-bold text-curtron-ink">Curtron Hub</div>
              <div className="text-[11px] text-curtron-muted">a service of Curtron Transport Services</div>
            </div>
          </div>

          <h1 className="font-heading text-2xl font-bold text-curtron-ink tracking-tight">How to receive dispatch text alerts from Curtron Hub</h1>

          <p className="text-sm text-curtron-sub leading-relaxed mt-5">
            Curtron Hub sends operational SMS dispatch alerts to authorized contract drivers of Curtron Transport Services when a transport call is assigned to them. Access is by invitation only — prospective drivers should contact their dispatcher or hiring manager to receive credentials.
          </p>

          <div className="mt-6 rounded-xl border border-curtron-line bg-curtron-bg/50 p-5">
            <h2 className="font-heading font-semibold text-curtron-ink text-sm flex items-center gap-2 mb-4">
              <User className="w-4 h-4 text-curtron-green" /> Once you have a Curtron Hub account, opt in from inside the app:
            </h2>
            <ol className="space-y-3">
              {STEPS.map((s, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full bg-curtron-green text-white text-xs font-semibold flex items-center justify-center shrink-0 mt-0.5">{i + 1}</span>
                  <span className="text-sm text-curtron-sub leading-relaxed">{s}</span>
                </li>
              ))}
            </ol>
          </div>

          <div className="mt-6 flex items-start gap-3 rounded-xl border border-curtron-info/30 bg-curtron-info/8 p-4">
            <MessageSquareText className="w-5 h-5 text-[#2f4b73] shrink-0 mt-0.5" />
            <p className="text-xs text-[#2f4b73] leading-relaxed">
              Message frequency varies (typically 1–5 messages per week). Msg &amp; data rates may apply. Reply STOP at any time to unsubscribe or HELP for help. Consent is not a condition of employment. Mobile numbers are never sold or shared with third parties for marketing purposes.
            </p>
          </div>

          <p className="text-sm text-curtron-sub mt-6 flex items-center gap-2">
            <CheckCircle2 className="w-4 h-4 text-curtron-green" /> Questions? Email{" "}
            <a href="mailto:support@curtronhub.com" className="text-curtron-green font-medium">support@curtronhub.com</a>
          </p>

          <div className="mt-8 pt-4 border-t border-curtron-line text-xs text-curtron-muted">
            © 2026 Curtron Transport Services. All rights reserved. ·{" "}
            <Link to="/privacy" className="text-curtron-green">Privacy Policy</Link> ·{" "}
            <Link to="/terms" className="text-curtron-green">Terms of Service</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
